/** Keys this CSMS may ChangeConfiguration. Network, URL, PIN, and power limits stay off-limits. */
export const OPERATOR_CONFIG_KEYS = [
  {
    key: 'EvccidEnabled',
    label: 'Send EVCC MAC (AutoCharge)',
    kind: 'bool',
    help: 'When true, the charger should report the vehicle PLC MAC after plug-in (idTag or DataTransfer).',
  },
  {
    key: 'EnableEVID',
    label: 'Enable EV identification',
    kind: 'bool',
    help: 'Sicon vendor switch for sending vehicle identity to this server.',
  },
  {
    key: 'AuthorizeRemoteTxRequests',
    label: 'Authorize RemoteStart with CSMS',
    kind: 'bool',
    help: 'If true, RemoteStart first sends Authorize. If false, the charger starts with the idTag we send.',
  },
  {
    key: 'OpenChargeModeEnable',
    label: 'Open charge (no badge)',
    kind: 'bool',
    extraConfirm: true,
    help: 'If true, plugging in may start charging without RFID or RemoteStart. Leave false unless you want that.',
  },
  {
    key: 'DefaultIdTag',
    label: 'Default idTag',
    kind: 'idTag',
    help: 'Optional id used when the charger starts a session without a badge (max 20).',
  },
];

export const OPERATOR_CONFIG_KEY_SET = new Set(OPERATOR_CONFIG_KEYS.map((row) => row.key));

export function isInterestingConfigKey(key) {
  const k = (key || '').toLowerCase();
  return /meter|clockaligned|authorize|iso|15118|autocharge|vin|vehicle|evcc|evid|mac|soc|localauth|offline|opencharge|defaultidtag|datatransmac/i.test(k);
}

export function configKeyName(row) {
  return row?.key || row?.Key || '';
}

export function configKeyValue(row) {
  if (row == null) return '';
  if (row.value === undefined || row.value === null) return row.Value ?? '';
  return row.value;
}

export function configKeyReadonly(row) {
  return Boolean(row?.readonly ?? row?.readonly_);
}

export function isTruthyConfig(value) {
  return String(value || '').trim().toLowerCase() === 'true';
}
